// extracted by mini-css-extract-plugin
export var hidden = "_pe-1";
export var visible = "_pe-0";